<template>
	<v-footer
		class="footer color-white font-size-12"
		color="black"
		v-if="!loadingStatus"
	>
		<MainColumn>
			<div class="row ">
				<div class="logos">
					<svg
						id="Logo_città_di_Lucca"
						data-name="Logo città di Lucca"
						xmlns="http://www.w3.org/2000/svg"
						width="70.171"
						height="110.5"
						viewBox="0 0 70.171 110.5"
					>
						<path
							id="Path_219"
							data-name="Path 219"
							d="M29.461,7.66h.148l1.847,5.983H51.472L53.319,7.66h.148a1.451,1.451,0,1,0-.665-.148,2.748,2.748,0,0,1-2.068.96,2.7,2.7,0,0,1-2.364-1.4,2.157,2.157,0,0,0,.665.148A1.482,1.482,0,0,0,50.512,5.74a1.441,1.441,0,0,0-1.034-1.4c0-.148.074-.222.074-.369a1.477,1.477,0,0,0-2.955,0,.666.666,0,0,0,.074.369,1.51,1.51,0,0,0-1.034,1.4,1.482,1.482,0,0,0,1.477,1.477,2.157,2.157,0,0,0,.665-.148,2.718,2.718,0,0,1-5.1-1.33V5.518a2.679,2.679,0,0,0,1.7-2.585,2.733,2.733,0,0,0-5.466,0,2.866,2.866,0,0,0,1.7,2.585V5.74a2.718,2.718,0,0,1-5.1,1.33,2.157,2.157,0,0,0,.665.148A1.482,1.482,0,0,0,37.66,5.74a1.441,1.441,0,0,0-1.034-1.4c0-.148.074-.222.074-.369a1.477,1.477,0,0,0-2.955,0,.666.666,0,0,0,.074.369,1.441,1.441,0,0,0-1.034,1.4,1.482,1.482,0,0,0,1.477,1.477,2.157,2.157,0,0,0,.665-.148,2.7,2.7,0,0,1-2.364,1.4,2.748,2.748,0,0,1-2.068-.96,1.523,1.523,0,0,0,.813-1.33,1.477,1.477,0,0,0-2.955,0C27.91,6.922,28.648,7.66,29.461,7.66Z"
							transform="translate(-7.302 -0.2)"
							fill="#fff"
						/>
						<path
							id="Path_220"
							data-name="Path 220"
							d="M62.094,75.415c0-.074.074-.148,0-.222h0c0-.369.369-.443.591-.443h.3a.973.973,0,0,0,.739-.517h0c.074-.074.148-.3-.074-.591a1.326,1.326,0,0,0-.517-.665,1.765,1.765,0,0,0-1.034-.369h-.222a1,1,0,0,1-.739-.369h0c-.074-.074-.074-.148-.148-.222a1.134,1.134,0,0,0-.96-.369.444.444,0,0,0-.3.074,2022.648,2022.648,0,0,0-.148.148c-.074.074-.148.074-.3.074a1.067,1.067,0,0,1-.517-.148h0a1.545,1.545,0,0,0-.443-.3,1.332,1.332,0,0,0-.739-.148,1.43,1.43,0,0,0-1.182.665h0a.671.671,0,0,1-.517.222c-.148,0-.222,0-.3-.074h0a1.05,1.05,0,0,0-.443-.148,15.155,15.155,0,0,0,3.028-3.545v.074c.148.739.886.886,1.551.3l.222-.222h0s.443-.443.813-.222a.671.671,0,0,0,.517.222,1.6,1.6,0,0,0,1.034-.443c.074-.074.148-.148.222-.148a1.608,1.608,0,0,0,.369-.591h0a.737.737,0,0,1,.3-.369,1.191,1.191,0,0,1,.665-.222h.074a2.771,2.771,0,0,0,.739-.074,2.268,2.268,0,0,0,.96-.591A3.472,3.472,0,0,0,66.3,65.3a5.089,5.089,0,0,1,.222-.591v-.074a.938.938,0,0,1,.3-.517c.074-.074.222-.148.3-.222.074,0,.074,0,.148-.074.074,0,.074-.074.148-.074.148-.074.222-.148.369-.222a.988.988,0,0,0,.443-.96c0-.074-.074-.148-.148-.222h0c-.222-.3.074-.591.148-.739h0a.072.072,0,0,0,.074-.074l.148-.148a.816.816,0,0,0,.3-.813h0a.6.6,0,0,0-.369-.443,2.527,2.527,0,0,0-.812-.148,3.1,3.1,0,0,0-1.108.3c-.074,0-.074.074-.148.074l-.074.074h0a.91.91,0,0,1-.813.148h0c-.074-.074-.148-.074-.3-.074a1.282,1.282,0,0,0-1.034.222l-.222.222-.074.074v.074c-.074.074-.074.148-.148.222a.7.7,0,0,1-.517.148h-.665a2.212,2.212,0,0,0-.739.3,1.149,1.149,0,0,0-.443.591,1.738,1.738,0,0,0-.148.591v.074a.8.8,0,0,1-.222.517.56.56,0,0,1-.3.148h0a1.05,1.05,0,0,0-.443.148,25.136,25.136,0,0,0,.96-4.432c.369.369.886.3,1.256-.3.074-.074.074-.148.148-.3h0s.222-.517.665-.369a.607.607,0,0,0,.517.074,1.375,1.375,0,0,0,.813-.665c.074-.074.074-.148.148-.222.074-.222.148-.369.222-.591h0a.564.564,0,0,1,.148-.369.855.855,0,0,1,.517-.369h.074a.912.912,0,0,0,.591-.3,2.781,2.781,0,0,0,1.034-1.7.809.809,0,0,0,0-.591h0a.993.993,0,0,1,.148-.591l.222-.222.074-.074c.074,0,.074-.074.148-.074.074-.074.148-.222.222-.3a.963.963,0,0,0,.148-.96c-.074-.074-.074-.148-.148-.148h0c-.222-.222-.074-.517,0-.665h0V50.6c0-.074.074-.074.074-.148a1.07,1.07,0,0,0,.074-.813c0-.074-.148-.222-.443-.3a1.472,1.472,0,0,0-.739.074,2.16,2.16,0,0,0-.886.517c-.074.074-.074.074-.074.148h0v.074h0a.71.71,0,0,1-.739.3h-.3a1.126,1.126,0,0,0-.813.443c-.074.074-.074.148-.148.222v.148c0,.074-.074.148-.074.222a.678.678,0,0,1-.443.3h0a1.369,1.369,0,0,0-.517.148,1.149,1.149,0,0,0-.591.443,2.624,2.624,0,0,0-.3.665,1.626,1.626,0,0,0,.074.591h0a.649.649,0,0,1-.074.517l-.222.222h0a1.615,1.615,0,0,0-.369.222l-.074.074a27.6,27.6,0,0,0-.148-3.25c.443,0,.739-.369.665-1.034a.444.444,0,0,0-.074-.3h0s-.148-.591.3-.739c.148,0,.3-.148.443-.222a1.447,1.447,0,0,0,.222-1.034v-.222a5.087,5.087,0,0,0-.222-.591h0c-.074-.148-.074-.3-.148-.443a1.392,1.392,0,0,1,.148-.591h0a1.485,1.485,0,0,0,.3-.591,2.371,2.371,0,0,0,.074-1.034,3.657,3.657,0,0,0-.3-.96.756.756,0,0,0-.369-.443h0a.671.671,0,0,1-.222-.517V41.659c-.074-.443-.222-.739-.517-.813h-.222c-.3,0-.443-.369-.443-.517h0v-.222q-.111-.554-.443-.665h0a.466.466,0,0,0-.517.074,1.554,1.554,0,0,0-.517.517,3.711,3.711,0,0,0-.369.96v.222h0a.782.782,0,0,1-.369.665c-.074.074-.148.074-.222.148a1.223,1.223,0,0,0-.369.886.444.444,0,0,0,.074.3,4044.826,4044.826,0,0,0,.148.148c0,.074.074.148.074.222a.792.792,0,0,1-.148.443h0a1.545,1.545,0,0,0-.3.443,2.185,2.185,0,0,0-.148.739,1.191,1.191,0,0,0,.222.665,1.958,1.958,0,0,0,.369.443h0a.526.526,0,0,1,.222.443c0,.148,0,.222-.074.3h0a1.05,1.05,0,0,0-.148.443v.148a1.186,1.186,0,0,0,.369.813,1.325,1.325,0,0,0,.517.369.778.778,0,0,1,.369.739h0v.222a2.156,2.156,0,0,0,1.256,1.625h.074a38.771,38.771,0,0,1-.074,5.909c-.074.074-.074.148-.148.3-.074-.074-.074-.148-.148-.222h0c-.074-.074-.148-.148-.148-.222a.488.488,0,0,1,.074-.443h0a1.05,1.05,0,0,0,.148-.443,2.045,2.045,0,0,0-.074-.665,1.325,1.325,0,0,0-.369-.517c-.148-.074-.222-.222-.369-.222h0a.577.577,0,0,1-.3-.3v-.369a.271.271,0,0,0-.074-.222.939.939,0,0,0-.591-.591c-.074,0-.148-.074-.222-.074-.3-.074-.443-.369-.517-.443h0v-.074c0-.074-.074-.074-.074-.148A1.744,1.744,0,0,0,57.588,52,1.165,1.165,0,0,0,57,51.778c-.3,0-.443.074-.443.148a.807.807,0,0,0-.148.739v.222h0c0,.148.074.443-.222.591h0a.258.258,0,0,0-.148.074,1.081,1.081,0,0,0-.148.886.384.384,0,0,0,.148.3c0,.074.074.074.074.148l.074.074c.074.074.074.148.148.3a.625.625,0,0,1,0,.517h0a1.068,1.068,0,0,0-.148.517,3.6,3.6,0,0,0,.074.886,1.761,1.761,0,0,0,.443.813,1.958,1.958,0,0,0,.443.369h0a.757.757,0,0,1,.369.443.8.8,0,0,1,.074.369h0v.591a.271.271,0,0,0,.074.222c.148.369.3.665.517.739a.937.937,0,0,0,.443.074c.369,0,.517.517.517.517h0a.558.558,0,0,0,.074.3c.222.665.739.813,1.182.517a20.494,20.494,0,0,1-3.915,8.051v-.517h0v-.369a.678.678,0,0,1,.3-.443h0a1.254,1.254,0,0,0,.443-.443,2.73,2.73,0,0,0,.369-.813,1.794,1.794,0,0,0,0-.886,1.068,1.068,0,0,0-.148-.517h0a1.1,1.1,0,0,1-.074-.517c0-.074.074-.222.074-.3l.074-.074c0-.074.074-.074.074-.148.074-.074.074-.222.148-.369a.872.872,0,0,0-.222-.886.271.271,0,0,0-.222-.074h0a1.557,1.557,0,0,1-.443-1.182h0v-.222a1.1,1.1,0,0,0-.222-.739.706.706,0,0,0-.517-.148,1.967,1.967,0,0,0-.591.3,2.892,2.892,0,0,0-.591.739c0,.074,0,.074-.074.148v.074h0c-.074.148-.148.443-.517.517-.074,0-.148.074-.222.074a1.3,1.3,0,0,0-.591.665v.591a.737.737,0,0,1-.3.369h0a.737.737,0,0,0-.369.3,1.608,1.608,0,0,0-.369.591,1.025,1.025,0,0,0,0,.665l.222.443h0a.488.488,0,0,1,.074.443c0,.074-.074.148-.148.222h0c-.074.074-.148.222-.222.3,0,.074-.074.074-.074.148a1.016,1.016,0,0,0,.074.813c.074.148.222.3.3.443a.775.775,0,0,1,.148.739h0c0,.074-.074.148-.074.222a1.708,1.708,0,0,0,.517,1.625,11.9,11.9,0,0,1-4.136,1.773q-.886.222-1.994.443c.074-.074.074-.222.148-.3h0c0-.074.074-.148.148-.222a.543.543,0,0,1,.443-.148h0a1.257,1.257,0,0,0,.517-.074,1.19,1.19,0,0,0,.517-.3.912.912,0,0,0,.3-.591.937.937,0,0,0,.074-.443h0a1.05,1.05,0,0,1,.148-.443c.074-.074.148-.074.148-.148h.148c.074,0,.148-.074.222-.148a1.111,1.111,0,0,0,.3-.813.271.271,0,0,0-.074-.222.626.626,0,0,1,.222-.665h0l.074-.074a.258.258,0,0,0,.074-.148,2.73,2.73,0,0,0,.369-.812,1.79,1.79,0,0,0,0-.665.442.442,0,0,0-.369-.369.959.959,0,0,0-.739.148c-.074,0-.074.074-.148.074l-.074.074h0c-.148.074-.369.3-.591.074h0l-.148-.148a.816.816,0,0,0-.813.3,1.02,1.02,0,0,0-.222.3.258.258,0,0,0-.074.148.072.072,0,0,1-.074.074l-.222.222a.638.638,0,0,1-.443.222h0a1.257,1.257,0,0,0-.517.074,1.968,1.968,0,0,0-.739.443,1.689,1.689,0,0,0-.517.739,1.738,1.738,0,0,0-.148.591h0a.8.8,0,0,1-.222.517c-.074.074-.222.148-.3.222h0a1.851,1.851,0,0,0-.517.3c-.074.074-.148.074-.148.148a1.283,1.283,0,0,0-.443.813,1.05,1.05,0,0,0,.148.443c.222.369-.222.665-.222.665h0c-.074.074-.148.074-.222.148a.725.725,0,0,0,0,1.256A51.552,51.552,0,0,0,34.1,79.256a53.288,53.288,0,0,0-9.233-3.915,6.994,6.994,0,0,0-3.915-5.688l-4.063-1.847a6.323,6.323,0,0,0,3.472,5.318,34.38,34.38,0,0,1,3.324,1.847c-1.773-.517-3.4-.96-4.8-1.256a11.143,11.143,0,0,1-4.21-1.847,7.576,7.576,0,0,0-.222-7.46L11.866,60.2a6.873,6.873,0,0,0-.074,7.017,29.664,29.664,0,0,1,1.92,3.915A18.137,18.137,0,0,1,8.1,61.75a7.731,7.731,0,0,0,3.545-7.091l-.591-4.653a7.062,7.062,0,0,0-3.176,6.278,37.143,37.143,0,0,1,0,5.17,33.354,33.354,0,0,1-.813-10.193c.222-.443.739-1.551,1.994-4.136A7.8,7.8,0,0,0,8.025,39,26.121,26.121,0,0,1,6.1,44.614a6.906,6.906,0,0,0,.665,6.8A21.523,21.523,0,0,0,6.7,54.733a7.759,7.759,0,0,0-5.17-6.2,25.931,25.931,0,0,1,1.33,5.761,6.885,6.885,0,0,0,4.284,5.466,24.319,24.319,0,0,0,1.108,4.432,1.545,1.545,0,0,0-.3-.443A8.494,8.494,0,0,0-.1,59.682a28.413,28.413,0,0,1,3.915,5.17,7.708,7.708,0,0,0,6.426,3.619A14.046,14.046,0,0,0,13.2,71.8,8.4,8.4,0,0,0,4.48,73.051a27.536,27.536,0,0,1,6.131,2.068,7.726,7.726,0,0,0,7.46-.739c.3.074.591.222.886.3,1.92.517,3.693,1.034,5.244,1.551-.517-.074-1.182-.148-1.92-.222a7.589,7.589,0,0,0-7.239,3.767,24.62,24.62,0,0,1,5.909-.148,6.906,6.906,0,0,0,5.835-2.511,46.164,46.164,0,0,1,6.278,2.955,21.057,21.057,0,0,0-5.1,4.136c-.96,1.182.3,1.551.3,1.551s1.33-2.29,5.761-5.1c4.506,2.807,5.761,5.1,5.761,5.1s1.256-.369.3-1.551a19.46,19.46,0,0,0-5.1-4.136,44.81,44.81,0,0,1,5.909-2.807.883.883,0,0,0,.813.665A.444.444,0,0,1,42,78h0s.591,0,.591.443a.7.7,0,0,0,.148.517,1.5,1.5,0,0,0,.886.517h1.33c.222.074.443.148.517.3h0a1.273,1.273,0,0,0,.443.443,2.9,2.9,0,0,0,.96.369,2.434,2.434,0,0,0,1.034,0c.222-.074.369-.148.591-.222h.665a.384.384,0,0,1,.3.148l.074.074c.074,0,.074.074.148.074.148.074.222.074.369.148.443.074.813,0,.96-.222a.271.271,0,0,0,.074-.222h0c.074-.3.443-.3.591-.3H51.9a1.188,1.188,0,0,0,.812-.222.49.49,0,0,0,.148-.517,1.5,1.5,0,0,0-.369-.665,3.28,3.28,0,0,0-.813-.591c-.074,0-.074-.074-.148-.074h-.074a.937.937,0,0,1-.591-.517c0-.074-.074-.148-.074-.222a1.174,1.174,0,0,0-.739-.591h-.665a.737.737,0,0,1-.369-.3h0a1.611,1.611,0,0,0-.3-.369,1.428,1.428,0,0,0-.665-.369,1.252,1.252,0,0,0-.739,0c-.148.074-.369.148-.517.222h0a.607.607,0,0,1-.517.074.56.56,0,0,1-.3-.148h0c-.074-.074-.148-.074-.222-.148,1.034-.3,2.142-.591,3.25-.886.517-.148,1.034-.3,1.477-.443,0,.074-.074.148-.074.222-.3.665.222,1.256,1.034,1.182a.666.666,0,0,0,.369-.074h0s.591-.148.813.3a.748.748,0,0,0,.3.517,1.651,1.651,0,0,0,1.108.3h.3L55,76.523h0a1.05,1.05,0,0,1,.443-.148,1.475,1.475,0,0,1,.665.148h0a1.428,1.428,0,0,0,.665.369,2.622,2.622,0,0,0,1.108.074,4.234,4.234,0,0,0,1.034-.3,1.325,1.325,0,0,0,.517-.369h0a.839.839,0,0,1,.591-.222h1.108C61.65,75.932,62.02,75.71,62.094,75.415Z"
							transform="translate(0.1 -10.341)"
							fill="#fff"
						/>
						<path
							id="Path_221"
							data-name="Path 221"
							d="M24.5,26.5V54.421A7.944,7.944,0,0,0,32.477,62.4h3.989a3.842,3.842,0,0,1,3.693,2.585h0c0,.148.148.222.3.222s.222-.074.3-.222h0A4.016,4.016,0,0,1,44.443,62.4h3.989a7.944,7.944,0,0,0,7.977-7.977V26.5ZM55.449,44.449H25.534V27.46H55.449Z"
							transform="translate(-6.329 -7.074)"
							fill="#fff"
						/>
						<path
							id="Path_222"
							data-name="Path 222"
							d="M8.647,142.1V130.5l-3.545.517v.443c.813,0,1.477.148,1.477,1.625v3.4h0a2.779,2.779,0,0,0-2.511-1.477c-2.807,0-3.767,2.142-3.767,4.8,0,2.364.665,4.8,3.4,4.8a3.1,3.1,0,0,0,2.881-1.625h.074v1.625l3.545-.517v-.443C9.311,143.722,8.647,143.5,8.647,142.1Zm-4.063,1.4c-1.7,0-2.142-1.625-2.142-3.693,0-1.92.443-3.841,2.142-3.841,1.551,0,1.994,1.4,1.994,3.841C6.578,141.727,6.283,143.5,4.584,143.5Z"
							transform="translate(-0.005 -34.255)"
							fill="#fff"
						/>
						<path
							id="Path_223"
							data-name="Path 223"
							d="M18.045,143.839V136.6l-3.545.517v.443c.813,0,1.477.148,1.477,1.625v4.727c0,1.4-.3,1.773-1.477,1.773v.443h5.023v-.443C18.341,145.538,18.045,145.242,18.045,143.839Z"
							transform="translate(-3.716 -35.85)"
							fill="#fff"
						/>
						<path
							id="Path_224"
							data-name="Path 224"
							d="M18.711,132.156a1.245,1.245,0,0,0-1.256-1.256,1.256,1.256,0,0,0,0,2.511A1.164,1.164,0,0,0,18.711,132.156Z"
							transform="translate(-4.16 -34.36)"
							fill="#fff"
						/>
						<path
							id="Path_225"
							data-name="Path 225"
							d="M37.422,143.683H35.944c-1.182,0-1.33-.3-1.33-1.477v-8.642c0-1.551.3-1.847,1.7-1.847V131.2H30.7v.517c1.4,0,1.7.3,1.7,1.847v8.642c0,1.551-.3,1.847-1.7,1.847v.517h9.75l.148-3.176h-.591C39.564,143.018,38.973,143.683,37.422,143.683Z"
							transform="translate(-7.95 -34.438)"
							fill="#fff"
						/>
						<path
							id="Path_226"
							data-name="Path 226"
							d="M53.381,143.691V136.6l-3.545.517v.443c.813,0,1.477.148,1.477,1.625v2.585c0,1.256-1.182,3.324-2.216,3.324-1.182,0-1.551-.665-1.551-3.1v-5.318L44,137.191v.443c.813,0,1.477.148,1.477,1.625v4.432c0,1.551.443,2.659,2.659,2.659a3.514,3.514,0,0,0,3.028-2.364h.074v2.364l3.545-.517v-.443C54.119,145.316,53.381,145.094,53.381,143.691Z"
							transform="translate(-11.426 -35.85)"
							fill="#fff"
						/>
						<path
							id="Path_227"
							data-name="Path 227"
							d="M63.541,137.239a.893.893,0,0,1,.96.665c.148.369,0,1.773,1.256,1.773a1.166,1.166,0,0,0,1.256-1.108c0-1.256-1.7-2.068-3.25-2.068-3.028,0-4.063,1.994-4.063,4.432,0,3.324,1.477,5.244,4.727,5.244a5.441,5.441,0,0,0,2.585-.517v-.739a7.913,7.913,0,0,1-1.773.3c-2.585,0-3.324-2.733-3.324-4.727C61.842,138.494,62.359,137.239,63.541,137.239Z"
							transform="translate(-15.529 -35.823)"
							fill="#fff"
						/>
						<path
							id="Path_228"
							data-name="Path 228"
							d="M75.141,137.239a.893.893,0,0,1,.96.665c.148.369,0,1.773,1.256,1.773a1.166,1.166,0,0,0,1.256-1.108c0-1.256-1.7-2.068-3.25-2.068-2.955,0-4.063,1.994-4.063,4.432,0,3.324,1.477,5.244,4.727,5.244a5.441,5.441,0,0,0,2.585-.517v-.739a7.913,7.913,0,0,1-1.773.3c-2.585,0-3.324-2.733-3.324-4.727C73.442,138.494,73.885,137.239,75.141,137.239Z"
							transform="translate(-18.561 -35.823)"
							fill="#fff"
						/>
						<path
							id="Path_229"
							data-name="Path 229"
							d="M90.947,145.511c-.665,0-.886-.443-.886-1.7v-3.989c0-2.29-.813-3.324-3.324-3.324-1.625,0-3.693.591-3.693,2.068a1.023,1.023,0,0,0,1.108,1.034c1.847,0,.443-2.438,2.438-2.438,1.4,0,1.4,1.551,1.4,2.585v1.034c-1.256.074-5.392.222-5.392,3.028a2.492,2.492,0,0,0,2.659,2.29,3.776,3.776,0,0,0,2.733-1.33c.148.665.369,1.33,1.551,1.33a6.862,6.862,0,0,0,2.142-.369v-.517A1.058,1.058,0,0,1,90.947,145.511Zm-2.955-2.733c0,1.477-.739,2.29-1.92,2.29a1.282,1.282,0,0,1-1.256-1.4c0-1.92,2.438-1.994,3.176-1.994v1.108Z"
							transform="translate(-21.514 -35.823)"
							fill="#fff"
						/>
						<path
							id="Path_230"
							data-name="Path 230"
							d="M29.824,120a5.554,5.554,0,0,1-3.545,1.034c-2.807,0-3.915-2.881-3.915-6.057,0-2.511.517-5.688,3.472-5.688a3.482,3.482,0,0,1,3.324,3.028h.591l-.148-3.324a12.992,12.992,0,0,0-3.989-.591c-4.506,0-5.614,2.955-5.614,6.648,0,4.506,1.551,7.165,5.909,7.165a8.713,8.713,0,0,0,3.841-.739V120Z"
							transform="translate(-5.153 -28.479)"
							fill="#fff"
						/>
						<path
							id="Path_231"
							data-name="Path 231"
							d="M39.411,109.556a1.245,1.245,0,0,0-1.256-1.256,1.256,1.256,0,1,0,1.256,1.256Z"
							transform="translate(-9.57 -28.453)"
							fill="#fff"
						/>
						<path
							id="Path_232"
							data-name="Path 232"
							d="M35.1,122.938v.443h5.023v-.443c-1.182,0-1.477-.369-1.477-1.773V114l-3.545.517v.443c.813,0,1.477.148,1.477,1.625v4.727C36.577,122.642,36.282,122.938,35.1,122.938Z"
							transform="translate(-9.1 -29.943)"
							fill="#fff"
						/>
						<path
							id="Path_233"
							data-name="Path 233"
							d="M46,109.7c-.074,1.551-.739,3.619-3.1,3.619v.591h1.625v5.983c0,2.364,1.477,2.659,3.25,2.659a2.7,2.7,0,0,0,1.108-.222v-.812a2.624,2.624,0,0,1-.739.148c-1.034,0-1.625-.369-1.625-1.7v-5.983H49.1v-.813H46.519v-3.324H46Z"
							transform="translate(-11.138 -28.819)"
							fill="#fff"
						/>
						<path
							id="Path_234"
							data-name="Path 234"
							d="M58.557,121.47a2.625,2.625,0,0,1-.739.148c-1.034,0-1.625-.369-1.625-1.7v-5.983h2.585v-.812H56.193V109.8H55.6c-.074,1.551-.739,3.619-3.1,3.619v.591h1.625v5.983c0,2.364,1.477,2.659,3.25,2.659a3.346,3.346,0,0,0,1.182-.222Z"
							transform="translate(-13.648 -28.845)"
							fill="#fff"
						/>
						<path
							id="Path_235"
							data-name="Path 235"
							d="M71.859,123.181v-.517a3.141,3.141,0,0,1-.812.148c-.665,0-.886-.443-.886-1.7v-3.989c0-2.29-.812-3.324-3.324-3.324-1.625,0-3.693.591-3.693,2.068a1.023,1.023,0,0,0,1.108,1.034c1.847,0,.443-2.438,2.438-2.438,1.4,0,1.4,1.551,1.4,2.585v1.034c-1.256.074-5.392.222-5.392,3.028a2.492,2.492,0,0,0,2.659,2.29,3.776,3.776,0,0,0,2.733-1.33c.148.665.369,1.33,1.551,1.33A4.209,4.209,0,0,0,71.859,123.181Zm-3.693-3.028c0,1.477-.739,2.29-1.92,2.29a1.282,1.282,0,0,1-1.256-1.4c0-1.92,2.438-1.994,3.176-1.994v1.108Z"
							transform="translate(-16.313 -29.891)"
							fill="#fff"
						/>
						<path
							id="Path_236"
							data-name="Path 236"
							d="M67.99,110.976l-.369-1.847c-.148-.812-.3-1.33-1.034-1.33-.517,0-.886.148-.886.665a1.918,1.918,0,0,0,.3.739l1.034,1.773Z"
							transform="translate(-17.097 -28.322)"
							fill="#fff"
						/>
					</svg>
					<Logo class="logo" />
				</div>
				<div class="infos ">
					<div class="data">
						<div class="label">Sede</div>
						<div
							class="value cursor"
							@click="
								openLinkInNewTab(
									'https://goo.gl/maps/Js66eMuFgdthsKpn6'
								)
							"
						>
							Via delle trombe, 6 55100 Lucca (LU) - ITALY
						</div>
						<div
							class="value cursor"
							@click="openLinkInNewTab('tel:+390583445716')"
						>
							+39 0583/445716
						</div>
						<div class="label">Succursale</div>
						<div
							class="value cursor"
							@click="
								openLinkInNewTab(
									'https://maps.app.goo.gl/2RAG8ayDgTaz3NfCA'
								)
							"
						>
							Via Consani angolo via della Formica a San Concordio<br>55100 Lucca (LU) - ITALY
						</div>
						<div
							class="value cursor"
							@click="openLinkInNewTab('tel:+390583442326')"
						>
							+39 0583/442326
						</div>
						<div
							class="font-weight-bold text-uppercase font-size-14"
							style="cursor: pointer"
							@click="
								updateProperty({
									property: 'subscriptionDialog',
									value: true
								})
							"
						>
							Iscriviti
						</div>
					</div>
					<div class="data">
						<div class="label">Contatti</div>
						<div
							class="value cursor"
							@click="
								openLinkInNewTab(
									'mailto:info@bibliotecaagora.it'
								)
							"
						>
							info@bibliotecaagora.it
						</div>
						<div class="label">Credits</div>
						<div
							class="value cursor"
							@click="openLinkInNewTab('https://qzrstudio.com')"
						>
							Design e realizzazione: QZR srl
						</div>
						<div
							class="font-weight-bold text-uppercase font-size-14"
							style="cursor: pointer"
							@click="
								openLinkInNewTab('https://bibliotecaagora.it/servizi/')
							"
						>
							FAQ
						</div>
					</div>
				</div>
				<div class="socials">
					<div class="label">Socials</div>
					<div class="social">
						<v-icon
							class="color-black cursor"
							@click="
								openLinkInNewTab(
									'https://www.facebook.com/Biblioteca-Civica-Agor%C3%A0-142566852552592'
								)
							"
							>mdi-facebook</v-icon
						>
					</div>
					<div class="social">
						<v-icon
							class="color-black cursor"
							@click="
								openLinkInNewTab(
									'https://www.instagram.com/bibliotecagora/'
								)
							"
							>mdi-instagram</v-icon
						>
					</div>
				</div>
			</div>
			<br class="clear" />
			<div class=" sponsor">
				<div class="data">
					<div class="label text-left">Contributo</div>
					<div class="cursor text-left">
						Il sito è stato realizzato con il contributo di
					</div>
				</div>

				<div class="logo-sponsor"></div>
				<div class="logo-sponsor-2"></div>
			</div>
		</MainColumn>
	</v-footer>
</template>

<script>
import Logo from "@/components/ui/Logo";
export default {
	name: "Footer",
	props: ["value", "color"],
	components: {
		Logo
	}
};
</script>

<style lang="scss" scoped>
.row {
	display: inline-block;
	width: 100%;
	border-bottom: 1px solid #fff;
	padding-bottom: $spacing-0;
}
.logo {
	display: inline-block;
	margin: 0 auto;
	margin-left: $spacing-1;
}
.label {
	font-weight: bold;
	text-transform: uppercase;
	margin-bottom: 0.5rem;
}
.value {
	margin-bottom: 0.5rem;
}
.data {
	float: left;
	width: 50%;
	padding-right: 25px;
}
footer {
	padding: $spacing-1 0;
}

.infos {
	width: calc(100% - 275px - 275px);
	float: left;
}

.logos {
	width: 275px;
	padding-right: 25px;
	float: left;
}

.socials {
	width: 275px;
	float: left;
}

.social {
	border-radius: 90px;
	margin-right: 1rem;
	padding: 10px;
	background: #fff;
	display: inline-block;
}

.address {
	padding: 10px 0;
}

.cursor {
	cursor: pointer;
}
.sponsor {
	width: 450px;
	max-width: 90vw;
	margin: auto;
	margin-top: $spacing-0;
	text-align: center;
}

.logo-sponsor,
.logo-sponsor-2 {
	background-image: url(https://bibliotecaagora.it/wp-content/uploads/2020/10/logo-legge.png);
	background-repeat: no-repeat;
	background-size: contain;
	background-position: center center;
	padding-top: 80px;
	margin-top: 1rem;
	width: 80px;
	display: inline-block;
	margin-right: 2rem;
}

.logo-sponsor-2 {
	background-image: url(https://bibliotecaagora.it/wp-content/uploads/2020/10/Centro-per-il-libro-e-la-lettura.png);
}

.sponsor span {
	padding: 1rem 0;
	display: inline-block;
}

@media only screen and (max-width: 1024px) {
	.socials,
	.logos,
	.data,
	.infos,
	.sponsor {
		width: 100%;
		margin-top: 1rem;
		float: none;
		clear: both;
		text-align: left;
	}
}
</style>
